// Spies, rescues and the fate of a captive royal (`espionage.enabled` and
// `diplomacy.dynasty`) — English. Merged in ./messages.ts.

export const gameEspionageEn = {
  'espionage.tab': 'Missions',
  'espionage.empty':
    'Nothing needs doing. Your spies are idle and no royal of your house is in chains.',
  'espionage.spies': 'Your spies',
  'espionage.noSpies': 'You have no spies. A spy may watch any enemy city next to them.',
  'espionage.endurance': 'Endurance {n}',
  'espionage.targets': 'Cities in reach',
  'espionage.dispatch': 'Send to watch',
  'espionage.sabotage': 'Sabotage ({gold} gold)',
  'espionage.sabotageUnderway': 'On its way: {n} ticks to go',
  'espionage.sabotageCooldown': 'Your spies need {n} ticks before the next blow',
  'espionage.sabotageRefused': 'The order was refused: check the spy, the purse and the network',
  'espionage.poison': 'Poison the {supply} ({gold} gold)',
  'espionage.poisoned': 'The {supply} is poisoned',
  'espionage.supplyWell': 'well',
  'espionage.supplyGranary': 'granary',
  'espionage.poisonRefused': 'The order was refused: check the spy, the purse and the network',
  'espionage.assassinate': 'Assassinate the {royal} ({gold} gold)',
  'espionage.assassinateRefused': 'The order was refused: check the assassin and the purse',
  'espionage.royalTargets': 'Royals within reach',
  'espionage.counterGuard': 'Guard {city}',
  'espionage.counterGuarding': 'Guarding {city}',
  'espionage.counterRecall': 'Stand down',
  'espionage.counterSweep': 'Sweep for hidden agents ({gold} gold)',
  'espionage.counterCatch': 'Try to catch the agent',
  'espionage.counterRefused': 'The order was refused: check the unit, the purse and the target',
  'espionage.frameLabel': 'Whom to blame',
  'espionage.frameNobody': 'Blame no one',
  'espionage.frameHouse': 'Blame {house}',
  'espionage.dispatched': 'Spy sent',
  'espionage.watching': 'Watching',
  'espionage.gathering': 'Gathering what it can hear…',
  'espionage.attackPrepared': 'They are massing troops',
  'espionage.attackNotPrepared': 'No troops massing',
  'espionage.units': '{n} units',
  'espionage.gold': '{n} gold',
  'espionage.people': '{n} souls',
  'espionage.loyalty': 'Loyalty {n}',
  'espionage.mood': 'Mood {n}',
  'espionage.faith': 'Faith {n}',
  'espionage.buildings': 'Buildings: {list}',
  'espionage.captives': 'Royals you hold',
  'espionage.agents': 'Agents you hold',
  'espionage.agentOf': '{kind} of {house}',
  'espionage.agentRansom': 'Ransom ({gold} gold)',
  'espionage.agentRelease': 'Let go',
  'espionage.agentExecute': 'Execute',
  'espionage.agentRefused': 'Their house cannot pay.',
  'espionage.agentKind.spy': 'A spy',
  'espionage.agentKind.assassin': 'An assassin',
  'espionage.taken': 'Your royals, taken',
  'espionage.heldSince': 'Held since tick {n}',
  'espionage.decision': 'Decision',
  'espionage.undecided': 'No decision yet',
  'espionage.choiceRansom': 'Ransom',
  'espionage.choiceHold': 'Hold',
  'espionage.choiceExecute': 'Execute',
  'espionage.choiceRelease': 'Release',
  'espionage.price': 'Price {n} gold',
  'espionage.payRansom': 'Pay the ransom',
  'espionage.rescue': 'Send a spy',
  'espionage.raid': 'Take the place by force',
  'espionage.alreadyTried': 'A rescue has already been tried here',
  'espionage.captor.title': 'What happens to {name}?',
  'espionage.captor.body':
    'You hold a royal of another house. The court will remember what you decide.',
  'espionage.captor.ransomBody': 'Ask for gold. If nobody pays, the royal is only held.',
  'espionage.captor.holdBody': 'Keep them. A held royal may yet slip away on their own.',
  'espionage.captor.executeBody': 'End it now. A death is remembered as a death.',
  'espionage.captor.releaseBody': 'Let them go. Nothing is gained and nothing is lost.',
  'espionage.captor.confirm': 'Decide',
  'espionage.captor.cancel': 'Not yet',
} as const;
